export default __webpack_public_path__ + "static/media/vector.b46321f6.svg";